import { CSSProperties } from 'react';

const TablerIcon = ({ icon, style, ...props }: { icon: string; style?: CSSProperties } & CSSProperties) => <i className={`ti ti-${icon}`} style={{ ...props, ...style }} />;

export default TablerIcon;
